<template>
  <Header
    v-if="categoriesConfiguration"
    :show-basket="mgnlProps?.showBasket"
    :show-my-account="mgnlProps?.showMyAccount"
    :show-store-finder="mgnlProps?.showStoreFinder"
    :category-configuration="categoriesConfiguration"
  />
  <ClientOnly v-if="mgnlProps?.showMyAccount">
    <AuthDrawer />
    <ResetPasswordModal />
  </ClientOnly>
</template>

<script lang="ts" setup>
import { HeaderBuilder, WrapperProps } from './Header.model';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';
import ResetPasswordModal from '~/pages/ResetPassword.vue';

const props = defineProps(WrapperProps);
const mgnlProps = HeaderBuilder.build(props);
const { $domain } = useNuxtApp();

const imageConfiguration = mgnlProps.imageConfiguration?.reduce((acc, currentValue) => {
  const { categoryId } = JSON.parse(currentValue.category);

  const imageSettings = currentValue.images?.map((imageConfig) => {
    const { alt, image, aspectRatio, mobileAspectRatio } = imageConfig;
    const srcSet = magnoliaGetters.getSrcSetImagesAsString(image, $domain.cmsAssetDomainPath, aspectRatio, mobileAspectRatio?.[0]?.aspectRatio);
    const url = magnoliaGetters.getDefaultSrcAsset(image, $domain.cmsAssetDomainPath);
    return {
      alt: magnoliaGetters.getAltImage(image, alt),
      srcSet,
      url,
      to: magnoliaGetters.getLinkAndName(imageConfig, $domain.cmsAssetDomainPath, imageConfig.switchable?.intLinkParam),
    };
  });

  return {
    ...acc,
    [categoryId]: { images: imageSettings },
  };
}, {});

const reducedCategoriesConfiguration = mgnlProps.categories?.reduce((acc, currentValue) => {
  try {
    const { categoryId } = JSON.parse(currentValue.category);

    const links = currentValue.additionalLinks?.map(link => magnoliaGetters.getLinkAndName(link, $domain.cmsAssetDomainPath, link.switchable?.intLinkParam));

    return {
      ...acc,
      [categoryId]: { links, images: imageConfiguration?.[categoryId]?.images },
    };
  }
  catch {
    return acc;
  }
}, {});

const categoriesConfiguration = {
  ...imageConfiguration,
  ...reducedCategoriesConfiguration,
  topLevelLinks: mgnlProps.topLevelLinks?.map(topLevel => magnoliaGetters.getExtendedLinkAndName(topLevel, $domain.cmsAssetDomainPath)),
};
</script>
